export default __webpack_public_path__ + "static/media/collection-img-sample1@2x.d0e5f731.png";